import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

// Read from /me on the shell's own query key: the request the shell already
// makes, never a second one.
//
// hosting_only: on the Server GTM hosting plan (api services/hostingPlan), so
// the questions about amounts and conversions are not asked yet.
// focus + modules: a workspace that started on Server GTM and opens up card
// by card (api services/workspaceFocus, lib/workspace-modules).
export const HOSTING_HOME = '/server-container';

function useMeShell() {
  return useQuery({
    queryKey: ['auth', 'me-shell'],
    queryFn: async () => (await api.get('/api/auth/me')).data,
    staleTime: 5 * 60_000,
    retry: false,
  });
}

export function useHostingOnly() {
  const { data } = useMeShell();
  return !!data?.hosting_only;
}

export function useWorkspaceFocus() {
  const { data } = useMeShell();
  return { focus: data?.focus || null, modules: data?.modules || [], hostingOnly: !!data?.hosting_only };
}
